import {defineField, defineType} from 'sanity'
import {MdOutlineAutoAwesomeMosaic} from 'react-icons/md'

export default defineType({
  name: 'posts-slider',
  title: 'Posts Slider',
  type: 'object',
  icon: MdOutlineAutoAwesomeMosaic,
  fields: [
    defineField({
      name: 'title',
      type: 'string',
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      name: 'posts',
      title: 'Posts',
      type: 'array',
      of: [{type: 'reference', to: [{type: 'blog.post'}]}],
    }),
  ],
  preview: {
    select: {
      title: 'title',
      posts: 'posts',
    },
    prepare({title, posts}) {
      return {
        title: title,
        subtitle: posts.length > 0 ? `${posts.length} posts` : 'No posts',
      }
    },
  },
})
